/**
 * Marca no topo das telas de autenticação.
 *
 * Quem chega ali costuma vir de um link de e-mail, e a tela pedia e-mail e
 * senha sem dizer de quem. Isso é exatamente a forma de uma página de phishing
 * — e ensinar a pessoa a digitar senha em tela sem identificação é péssimo
 * hábito de segurança, mesmo quando a tela é legítima.
 *
 * O ícone é `aria-hidden`: o nome ao lado já diz tudo, e um leitor de tela
 * anunciando "imagem Movhuman, Movhuman" só atrapalha.
 */

import { useTranslation } from 'react-i18next';

/**
 * `compact` é a variante do cabeçalho de dentro do aplicativo.
 *
 * Sem a linha de apoio e com ícone menor: ali a pessoa já sabe onde está, e o
 * que se resolve é a falta de identidade quando o app roda instalado, sem a
 * barra de endereço do navegador. Em tela de celular, altura é o recurso mais
 * escasso — uma barra que só carrega logotipo custa caro.
 */
export function Brand({ compact = false }: { compact?: boolean }) {
  const { t } = useTranslation(['common']);
  const size = compact ? 28 : 44;

  return (
    <div className={compact ? 'flex items-center gap-2' : 'mb-8 flex items-center gap-3'}>
      <img
        src="/icons/icon-192.png"
        alt=""
        aria-hidden="true"
        width={size}
        height={size}
        className={compact ? 'rounded-lg' : 'rounded-xl'}
      />
      <div>
        <p
          className={[
            'font-display font-semibold leading-none text-(--color-sand-900)',
            compact ? 'text-base' : 'text-lg',
          ].join(' ')}
        >
          {t('common:app.name')}
        </p>
        {compact ? null : (
          <p className="mt-1 text-xs text-(--color-sand-500)">{t('common:app.tagline')}</p>
        )}
      </div>
    </div>
  );
}
